// Legal Services Page
import image from 'images/illustrations/family.png';

export const family = {
  intro: {
    heading: 'Look after your loved ones',
    copy: [
      'With our network of caregivers and advisors, you’ll be able to take care of your big responsibilities and look after your most important people.',
    ],
  },

  cta: {
    buttons: [
      {
        button: 'primary',
        label: 'Chat with a specialist',
        link: 'https://rms.workplaceoptions.com/anonymouschat/D509C30F-7FB2-431F-8646-8CBD8F945634/6055e8aa-c309-4bd0-a3fc-89a6a81bd053/00000000-0000-0000-0000-000000000000/11E7A159-E5E5-4FE2-A57F-F8567597ECD3',
      },
      {
        button: 'primary',
        label: 'Search services',
        action: 'searchServices',
      },
    ],
    number: '8778534706',
    copy: 'to find the right care',
  },

  iconList: [
    {
      icon: 'star',
      title: 'Get access to a range of providers &amp; services',
      copy: [
        'Access an online catalog of quality care providers for child care, adult care, educational matters and adoption services',
      ],
    },
  ],

  helpList: [
    'Child care',
    'Adult care',
    'Adoption',
    'Pet care',
    'Parenting',
    'Education',
    'Dependents with special needs',
  ],

  image,
};



// WEBPACK FOOTER //
// ./client/models/services/family.js